import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'keys',
    standalone: false
})
export class KeysPipe implements PipeTransform {
    transform(value, args: string[]): any {
        const keys = [];
        for (const key in value) {
            keys.push(key);
        }
        return keys;
    }
}


@Pipe({ name: 'keysValueCustom' })
export class keysValueCustomPipe implements PipeTransform {
    transform(value): any {

        const array = [];
        if (typeof value === 'object') {
            Object.keys(value).forEach(item => {
                array.push({
                    value: value[item],
                    key: item
                });
            });
            return array;
        }
        return array;

    }
}
